import { render, staticRenderFns } from "./DigitalPostSearchView.vue?vue&type=template&id=0f87725d&"
import script from "./DigitalPostSearchView.vue?vue&type=script&lang=js&"
export * from "./DigitalPostSearchView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports